<form class="form">
  <div class="d-flex flex-row">
    <div class="p-2 w-50">{{'STYLER.minScale' | translateHs }}:</div>
    <div class="p-1 w-50">
      <div class="input-group">
        <div class="input-group-text">1:</div>
        <input class="form-control" type="number" [ngModelOptions]="{standalone: true}"
          [(ngModel)]="scaleDenominator.min" (change)="emitChange()" />
      </div>
    </div>
  </div>
  <div class="d-flex flex-row">
    <div class="p-2 w-50">{{'STYLER.maxScale' | translateHs }}:</div>
    <div class="p-1 w-50">
      <div class="input-group">
        <div class="input-group-text">1:</div>
        <input class="form-control" type="number" [ngModelOptions]="{standalone: true}"
          [(ngModel)]="scaleDenominator.max" (change)="emitChange()" />
      </div>
    </div>
  </div>
</form>